__turbopack_context__.v({
  "MagazineTrendCard": "_2cZGQW_MagazineTrendCard",
  "MagazineTrendCardContent": "_2cZGQW_MagazineTrendCardContent",
  "MagazineTrendCardIcon": "_2cZGQW_MagazineTrendCardIcon",
  "MagazineTrendCardImage": "_2cZGQW_MagazineTrendCardImage",
  "MagazineTrendCardLink": "_2cZGQW_MagazineTrendCardLink",
  "MagazineTrendCardTitle": "_2cZGQW_MagazineTrendCardTitle",
});
